var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgB4LogoIhrNonProfit(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 243.26 71.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#76c045;}.cls-2{fill:#585757;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 55.53,
    width: 14.92,
    height: 14.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.54,
    y: 55.53,
    width: 14.92,
    height: 14.92
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.5,
    y: 55.53,
    width: 14.92,
    height: 14.92
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.54,
    y: 34.27,
    width: 14.92,
    height: 14.92
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 34.27,
    width: 14.92,
    height: 14.92
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 12.07,
    width: 14.92,
    height: 14.92
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 53.05,
    y: 31.67,
    width: 14.92,
    height: 14.92,
    transform: "translate(1.6 81.64) rotate(-70.85)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 29.3,
    y: 8.51,
    width: 14.92,
    height: 14.92,
    transform: "translate(-5.41 14.68) rotate(-24.25)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 55.46,
    y: 2.59,
    width: 14.92,
    height: 14.92,
    transform: "translate(-2.81 5.05) rotate(-6.22)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.56,35.71c0,3.89-.81,6.89-2.42,9a8.08,8.08,0,0,1-6.81,3.15A7,7,0,0,1,90.48,45l-.3,2.44H83.54V13.65h7.4V25.53a6.81,6.81,0,0,1,5.34-2.35,8.09,8.09,0,0,1,6.86,3.19q2.42,3.18,2.42,9Zm-7.43-.48a9.67,9.67,0,0,0-.91-4.88,3.07,3.07,0,0,0-2.8-1.45,3.56,3.56,0,0,0-3.48,1.9v9.44a3.57,3.57,0,0,0,3.52,1.88,3.14,3.14,0,0,0,3.32-2.54A18.53,18.53,0,0,0,98.13,35.23Z",
    transform: "translate(-2.09 -1.82)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.21,47.4a8.5,8.5,0,0,1-.7-2.13,6.9,6.9,0,0,1-5.71,2.57,8.42,8.42,0,0,1-5.72-2,6.47,6.47,0,0,1-2.35-5.1,6.65,6.65,0,0,1,2.86-5.85q2.85-2,8.3-2h2.29V31.61q0-3.28-2.84-3.29a2.32,2.32,0,0,0-2.63,2.61H108.3a6.64,6.64,0,0,1,2.94-5.6,12.34,12.34,0,0,1,7.48-2.15,10.78,10.78,0,0,1,7.18,2.22,7.74,7.74,0,0,1,2.71,6.09V42a10.56,10.56,0,0,0,1,5v.38Zm-4.63-4.84a4.08,4.08,0,0,0,2.29-.59,3.7,3.7,0,0,0,1.31-1.34v-3.8H119c-2.58,0-3.87,1.15-3.87,3.47a2.15,2.15,0,0,0,.68,1.64A2.49,2.49,0,0,0,117.58,42.56Z",
    transform: "translate(-2.09 -1.82)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.15,40.72a1.71,1.71,0,0,0-1-1.52A15,15,0,0,0,140.41,38a17.15,17.15,0,0,1-4.58-1.61A7.7,7.7,0,0,1,133.09,34a5.78,5.78,0,0,1-1-3.27,6.57,6.57,0,0,1,2.71-5.4,11.15,11.15,0,0,1,7.07-2.12,12.33,12.33,0,0,1,7.56,2.13,6.68,6.68,0,0,1,2.86,5.61h-7.43c0-1.91-1-2.86-3-2.86a3,3,0,0,0-2,.65,2,2,0,0,0-.79,1.61,1.86,1.86,0,0,0,1,1.61,9.21,9.21,0,0,0,3.09,1,27.16,27.16,0,0,1,3.72.94c3.58,1.23,5.36,3.44,5.36,6.62a6.2,6.2,0,0,1-2.89,5.29,12.6,12.6,0,0,1-7.48,2.05,13,13,0,0,1-5.45-1.1,9.18,9.18,0,0,1-3.73-3,6.73,6.73,0,0,1-1.34-4h6.92a2.86,2.86,0,0,0,1.1,2.41,4.54,4.54,0,0,0,2.7.76,3.53,3.53,0,0,0,2.27-.62A2,2,0,0,0,145.15,40.72Z",
    transform: "translate(-2.09 -1.82)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.26,47.84a12.22,12.22,0,0,1-8.86-3.27A11.23,11.23,0,0,1,155,36.08v-.61A14.59,14.59,0,0,1,156.37,29a9.88,9.88,0,0,1,3.94-4.32,11.89,11.89,0,0,1,6.15-1.53,10.33,10.33,0,0,1,7.92,3.11q2.9,3.11,2.9,8.67v2.88H162.55A5.39,5.39,0,0,0,164.29,41a5.16,5.16,0,0,0,3.47,1.14,6.64,6.64,0,0,0,5.49-2.46l3.39,4a9.36,9.36,0,0,1-3.92,3A13.22,13.22,0,0,1,167.26,47.84Zm-.84-18.94q-3.25,0-3.87,4.3H170v-.57a3.68,3.68,0,0,0-.9-2.76A3.59,3.59,0,0,0,166.42,28.9Z",
    transform: "translate(-2.09 -1.82)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M199.69,34.89h3.25v5.72h-3.25V47.4h-7.41V40.61H179.91l-.44-4.53,12.81-20.61V15.4h7.41Zm-13.16,0h5.75V25.05l-.46.75Z",
    transform: "translate(-2.09 -1.82)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.87,47.4h-7.69v-32h7.69Z",
    transform: "translate(-2.09 -1.82)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.35,21.36h-9.6v26H228v-26h-9.42v-6h26.74Z",
    transform: "translate(-2.09 -1.82)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.41,70.08h-2.1L85.93,61.5v8.58h-2.1V58h2.1l5.4,8.61V58h2.08Z",
    transform: "translate(-2.09 -1.82)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.32,65.5a5.3,5.3,0,0,1,.53-2.38,3.77,3.77,0,0,1,1.46-1.62,4.17,4.17,0,0,1,2.18-.57,3.92,3.92,0,0,1,3,1.17,4.64,4.64,0,0,1,1.23,3.11v.47a5.32,5.32,0,0,1-.51,2.37,3.71,3.71,0,0,1-1.46,1.62,4.16,4.16,0,0,1-2.19.57A3.93,3.93,0,0,1,96.46,69a4.87,4.87,0,0,1-1.14-3.38Zm2,.18a3.63,3.63,0,0,0,.57,2.17,1.88,1.88,0,0,0,1.6.78,1.84,1.84,0,0,0,1.59-.79,4,4,0,0,0,.56-2.34,3.56,3.56,0,0,0-.58-2.15,2,2,0,0,0-3.16,0A3.94,3.94,0,0,0,97.34,65.68Z",
    transform: "translate(-2.09 -1.82)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.25,61.1l.06,1a3.22,3.22,0,0,1,2.61-1.2c1.87,0,2.83,1.07,2.86,3.21v5.94h-2V64.26a1.85,1.85,0,0,0-.37-1.27,1.55,1.55,0,0,0-1.2-.41,1.94,1.94,0,0,0-1.82,1.11v6.39h-2v-9Z",
    transform: "translate(-2.09 -1.82)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M118.75,65.75h-4.36V64.13h4.36Z",
    transform: "translate(-2.09 -1.82)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.71,65.6v4.48h-2.1V58h4.62a4.67,4.67,0,0,1,3.22,1.06,3.55,3.55,0,0,1,1.19,2.79,3.43,3.43,0,0,1-1.17,2.77,4.88,4.88,0,0,1-3.26,1Zm0-1.7h2.52a2.48,2.48,0,0,0,1.71-.52,2,2,0,0,0,.59-1.53,2.08,2.08,0,0,0-.6-1.56,2.29,2.29,0,0,0-1.64-.6h-2.58Z",
    transform: "translate(-2.09 -1.82)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136,62.94a4.47,4.47,0,0,0-.82-.07,1.85,1.85,0,0,0-1.87,1.07v6.14h-2v-9h1.93l.05,1a2.27,2.27,0,0,1,2-1.17,1.87,1.87,0,0,1,.72.12Z",
    transform: "translate(-2.09 -1.82)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.58,65.5a5.3,5.3,0,0,1,.52-2.38,3.85,3.85,0,0,1,1.47-1.62,4.11,4.11,0,0,1,2.17-.57,3.9,3.9,0,0,1,2.95,1.17,4.59,4.59,0,0,1,1.23,3.11v.47a5.32,5.32,0,0,1-.51,2.37A3.77,3.77,0,0,1,143,69.67a4.22,4.22,0,0,1-2.2.57,3.89,3.89,0,0,1-3-1.26,4.87,4.87,0,0,1-1.14-3.38Zm2,.18a3.56,3.56,0,0,0,.58,2.17,2,2,0,0,0,3.18,0,4,4,0,0,0,.57-2.34,3.56,3.56,0,0,0-.59-2.15,2,2,0,0,0-3.16,0A4,4,0,0,0,138.59,65.68Z",
    transform: "translate(-2.09 -1.82)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M147.34,70.08V62.59H146V61.1h1.37v-.82a3.09,3.09,0,0,1,.83-2.31,3.17,3.17,0,0,1,2.33-.82,4.69,4.69,0,0,1,1.13.15l0,1.58a4.31,4.31,0,0,0-.77-.07,1.3,1.3,0,0,0-1.45,1.49v.8h1.83v1.49h-1.83v7.49Z",
    transform: "translate(-2.09 -1.82)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.66,58.76A1.06,1.06,0,0,1,153,58a1.12,1.12,0,0,1,.84-.3,1.14,1.14,0,0,1,.85.3,1.06,1.06,0,0,1,.3.77,1,1,0,0,1-.3.76,1.15,1.15,0,0,1-.85.31,1.12,1.12,0,0,1-.84-.31A1,1,0,0,1,152.66,58.76Zm2.15,11.32h-2v-9h2Z",
    transform: "translate(-2.09 -1.82)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.53,58.91V61.1h1.58v1.49h-1.58v5a1.14,1.14,0,0,0,.2.75,1,1,0,0,0,.73.23,2.8,2.8,0,0,0,.7-.09v1.56a4.79,4.79,0,0,1-1.32.19c-1.55,0-2.33-.85-2.33-2.56V62.59H156V61.1h1.48V58.91Z",
    transform: "translate(-2.09 -1.82)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.57,65.75h-4.36V64.13h4.36Z",
    transform: "translate(-2.09 -1.82)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M171.15,58l3.49,9.27L178.11,58h2.72V70.08h-2.09v-4l.2-5.33-3.57,9.32h-1.5l-3.56-9.31.21,5.32v4h-2.09V58Z",
    transform: "translate(-2.09 -1.82)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M188.48,70.08a3.18,3.18,0,0,1-.23-.84,3.41,3.41,0,0,1-4.57.23,2.46,2.46,0,0,1-.85-1.91,2.53,2.53,0,0,1,1.07-2.2,5.16,5.16,0,0,1,3-.77h1.23V64a1.59,1.59,0,0,0-.39-1.12,1.56,1.56,0,0,0-1.18-.41,1.77,1.77,0,0,0-1.13.34,1,1,0,0,0-.44.88h-2a2.23,2.23,0,0,1,.49-1.39,3.43,3.43,0,0,1,1.33-1,4.74,4.74,0,0,1,1.88-.36,3.84,3.84,0,0,1,2.52.79,2.85,2.85,0,0,1,1,2.23v4a4.56,4.56,0,0,0,.34,1.94v.14Zm-2.21-1.46a2.23,2.23,0,0,0,1.12-.29,1.86,1.86,0,0,0,.79-.78V65.86H187.1a3,3,0,0,0-1.69.39,1.26,1.26,0,0,0-.56,1.11,1.16,1.16,0,0,0,.38.92A1.5,1.5,0,0,0,186.27,68.62Z",
    transform: "translate(-2.09 -1.82)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.18,61.1l.06,1a3.25,3.25,0,0,1,2.62-1.2q2.8,0,2.85,3.21v5.94h-2V64.26a1.91,1.91,0,0,0-.37-1.27,1.58,1.58,0,0,0-1.21-.41,1.94,1.94,0,0,0-1.82,1.11v6.39h-2v-9Z",
    transform: "translate(-2.09 -1.82)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.13,70.08a3.18,3.18,0,0,1-.23-.84,3.14,3.14,0,0,1-2.36,1,3.17,3.17,0,0,1-2.21-.77,2.49,2.49,0,0,1-.85-1.91,2.56,2.56,0,0,1,1.07-2.2,5.18,5.18,0,0,1,3-.77h1.23V64a1.59,1.59,0,0,0-.39-1.12,1.56,1.56,0,0,0-1.18-.41,1.77,1.77,0,0,0-1.13.34,1,1,0,0,0-.44.88h-2a2.23,2.23,0,0,1,.49-1.39,3.43,3.43,0,0,1,1.33-1,4.74,4.74,0,0,1,1.88-.36,3.84,3.84,0,0,1,2.52.79,2.85,2.85,0,0,1,1,2.23v4a4.56,4.56,0,0,0,.34,1.94v.14Zm-2.21-1.46a2.2,2.2,0,0,0,1.12-.29,1.86,1.86,0,0,0,.79-.78V65.86h-1.08a3,3,0,0,0-1.69.39,1.28,1.28,0,0,0-.56,1.11,1.2,1.2,0,0,0,.38.92A1.52,1.52,0,0,0,204.92,68.62Z",
    transform: "translate(-2.09 -1.82)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M210.61,65.52a5.29,5.29,0,0,1,1-3.34,3.18,3.18,0,0,1,2.62-1.25A3,3,0,0,1,216.62,62l.09-.9h1.82v8.7a3.63,3.63,0,0,1-1.1,2.79,4.18,4.18,0,0,1-3,1,4.68,4.68,0,0,1-1.93-.41,3.48,3.48,0,0,1-1.43-1.07l1-1.21a2.89,2.89,0,0,0,2.29,1.1,2.23,2.23,0,0,0,1.58-.54,2.09,2.09,0,0,0,.58-1.6v-.61a3,3,0,0,1-2.32,1A3.15,3.15,0,0,1,211.61,69,5.41,5.41,0,0,1,210.61,65.52Zm2,.18a3.56,3.56,0,0,0,.55,2.12,1.78,1.78,0,0,0,1.53.78,1.93,1.93,0,0,0,1.81-1V63.6a1.91,1.91,0,0,0-1.79-1,1.81,1.81,0,0,0-1.55.79A4.05,4.05,0,0,0,212.62,65.7Z",
    transform: "translate(-2.09 -1.82)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224.56,70.24a4.18,4.18,0,0,1-3.11-1.2,4.37,4.37,0,0,1-1.19-3.22v-.25a5.29,5.29,0,0,1,.52-2.4,3.85,3.85,0,0,1,3.54-2.24,3.53,3.53,0,0,1,2.84,1.17,4.92,4.92,0,0,1,1,3.31v.82h-5.87A2.74,2.74,0,0,0,223,68a2.24,2.24,0,0,0,1.64.64,2.72,2.72,0,0,0,2.26-1.12l1.09,1a3.64,3.64,0,0,1-1.44,1.25A4.47,4.47,0,0,1,224.56,70.24Zm-.24-7.69a1.68,1.68,0,0,0-1.34.58,3.08,3.08,0,0,0-.66,1.62h3.85V64.6a2.49,2.49,0,0,0-.54-1.53A1.67,1.67,0,0,0,224.32,62.55Z",
    transform: "translate(-2.09 -1.82)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.43,62.94a4.5,4.5,0,0,0-.83-.07,1.85,1.85,0,0,0-1.86,1.07v6.14h-2v-9h1.93l0,1a2.26,2.26,0,0,1,2-1.17,1.78,1.78,0,0,1,.71.12Z",
    transform: "translate(-2.09 -1.82)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgB4LogoIhrNonProfit);
export default __webpack_public_path__ + "static/media/b4_Logo_IhrNonProfit.c295eebbc022d41d66b563ec1d495d6e.svg";
export { ForwardRef as ReactComponent };